module.exports = __webpack_public_path__ + "img/mastiha.7dc326b3.jpg";